import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M10.992 20H9V15H4V13H11L10.992 20ZM20 11H13L13.007 4H15V9H20V11Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Shrink"
);
